import { ArrivalScanResponse } from '../services/arrivalScan.endpoints';
import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'arrival_scanned_items';

export const useArrivalHistory = () => {
  const [scannedItems, setScannedItems] = useState<ArrivalScanResponse[]>(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(scannedItems));
  }, [scannedItems]);

  const addScannedItem = useCallback((item: ArrivalScanResponse) => {
    setScannedItems((prev) => [item, ...prev].slice(0, 10));
  }, []);

  const clearScannedItems = useCallback(() => {
    setScannedItems([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return {
    scannedItems,
    addScannedItem,
    clearScannedItems,
  };
};
